export class Perfil {
    constructor(public tipo: string, public id_sistema: number,  public id_perfil: number, public nom_perfil: string, public nombre_usuario: string) {}
} 